export default __webpack_public_path__ + "static/media/zeroGuide1.e1ab6f68.png";